module.exports = __webpack_public_path__ + "img/restaurant-price_bg.4a00030d.svg";